import { AppState } from '../root.reducer';

export const getClaimResponseDeadlineExtensionsStateByClaimId = (state: AppState, claimId: string) => {
  return state.claimResponseDeadlineExtensions.byClaimId[claimId];
};
